import { render, staticRenderFns } from "./ReportDataTable.vue?vue&type=template&id=721f007c&scoped=true&"
import script from "./ReportDataTable.vue?vue&type=script&lang=js&"
export * from "./ReportDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportDataTable.vue?vue&type=style&index=0&id=721f007c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f007c",
  null
  
)

export default component.exports